import axios from "axios";
import {getHeader, getOfferCategories, getOfferDetailsURL, getOffersLink} from "./../../config";
import {types} from "../types/globalTypes";
import {offerTypes} from "../types/offerTypes";


export const getOffers = (is_featured = 1, category_id = null, limit, offset, most_viewed = null) => {
    let postData = {
        is_featured: is_featured,
        limit: limit,
        offset: offset,
    };
    if (most_viewed) {
        postData = {
            ...postData,
            most_viewed,
        }
    }
    if (category_id) {
        postData = {
            ...postData,
            category_id
        }
    }
    return (dispatch, getState) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        // dispatch start loading
        dispatch({
            type: offerTypes.FETCHING_MORE_OFFERS,
            payload: true
        });
        axios.post(getOffersLink, postData, {headers: getHeader()}).then(res => {
            let offersListType = 0;   // [ 0 =>  offers, 1 => featured, 2 => most viewed ]
            if (!is_featured && !most_viewed) {
                offersListType = 0;
            } else if (is_featured) {
                offersListType = 1;
            } else if (most_viewed) {
                offersListType = 2;
            } else {
                offersListType = 0;
            }


            if (res.data.Error.code === 20) {
                let payload;
                switch (offersListType) {
                    case 0:
                        payload = {
                            offers: res.data.Response,
                            currentOfferCategory: category_id,
                        };
                        dispatch({
                            type: offerTypes.GET_OFFERS,
                            payload
                        });
                        break;
                    case 1:
                        payload = {
                            featured_offers: res.data.Response
                        };
                        dispatch({
                            type: offerTypes.GET_FEATURED_OFFERS,
                            payload
                        });
                        break;
                    case 2:
                        payload = {
                            most_viewed_offers: res.data.Response
                        };
                        dispatch({
                            type: offerTypes.GET_MOST_VIEWED_OFFERS,
                            payload
                        });
                        break;
                    default:
                    //
                }


                if (res.data.Response.length < limit) {
                    dispatch({
                        type: offerTypes.NO_MORE_OFFERS,
                        payload: true
                    });
                }
                dispatch({
                    type: offerTypes.FETCHING_MORE_OFFERS,
                    payload: false
                });
            }
        }).catch(err => {

            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        });
    }
};
export const getOfferCategoriesList = (speciality_id = -1) => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.get(getOfferCategories + "?" + "speciality_id=" + speciality_id, {headers: getHeader()}).then(res => {
            if (res.data.Error.code === 20) {
                dispatch({
                    type: offerTypes.GET_OFFERS_CATEGORIES,
                    payload: res.data.Response
                });
            }
        }).catch(err => {
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        })
    }
};
export const getOfferDetails = (offer_id) => {
    return (dispatch) => {
        dispatch({
            type: types.ERROR_500,
            payload: false,
        });
        axios.post(getOfferDetailsURL, {offer_id: offer_id}, {headers: getHeader()}).then(res => {
            if (res.data.Error.code === 20) {
                dispatch({
                    type: offerTypes.GET_OFFER_DETAILS,
                    payload: res.data.Response
                });
            } else if (res.data.Error.code === 24) {
                dispatch({
                    type: offerTypes.OFFER_ID_NOT_FOUND,
                    payload: null,
                })
            }
        }).catch(err => {
            dispatch({
                type: types.ERROR_500,
                payload: true,
            });
        })
    }
}
export const setOfferCategory = (offer_category_id) => {
    return (dispatch, getState) => {
        dispatch({
            type: offerTypes.SET_OFFER_CATEGORY,
            payload: offer_category_id
        });
    }
};
export const clearOfferDetails = () => {
    return (dispatch, getState) => {
        dispatch({
            type: offerTypes.CLEAR_OFFER_DETAILS,
            payload: null
        });
    }
};
export const clearOfferCategory = () => {
    return (dispatch, getState) => {
        dispatch({
            type: offerTypes.CLEAR_OFFER_CATEGORY,
            payload: null
        });
    }
};
export const clearOfferListAndCategories = () => {
    return (dispatch, getState) => {
        dispatch({
            type: offerTypes.CLEAR_OFFER_LIST_AND_CATEGORIES,
            payload: []
        });
    }
};
export const clearOfferList = () => {
    return (dispatch, getState) => {
        dispatch({
            type: offerTypes.CLEAR_OFFER_LIST,
            payload: []
        });
    }
};
export const clearShowMore = () => {
    return (dispatch, getState) => {
        dispatch({
            type: offerTypes.CLEAR_SHOW_MORE,
            payload: []
        });
    }
};